let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("91SIJ")).then(() => parcelRequire('bmeQi'));